import axios from 'axios';
import BaseApi from './base-api';

class ProposalsApi extends BaseApi {
  approve(proposalId, quotesId) {
    const data = {
      proposal: {
        quote_ids: quotesId,
      },
    };

    return axios
      .put(`${this.baseUrl}/proposals/${proposalId}/approve`, data)
      .then((response) => {
        return {
          ok: true,
          proposal: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  create(
    workOrderId,
    startDate,
    completionDate,
    markups,
    qualifications,
    deposit
  ) {
    const data = {
      proposal: {
        work_order_id: workOrderId,
        start_date: startDate,
        completion_date: completionDate,
        proposal_quotes_attributes: markups,
        proposal_qualifications_attributes: qualifications,
        deposit_attributes: deposit,
      },
    };
    return axios
      .post(this.baseUrl + '/proposals', data)
      .then((response) => {
        return {
          ok: true,
          proposal: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  reject(proposalId, password, reason1, reason2) {
    const data = {
      proposal: {
        password: password,
        rejected_reason_1: reason1,
        rejected_reason_2: reason2,
      },
    };

    return axios
      .put(`${this.baseUrl}/proposals/${proposalId}/reject`, data)
      .then((response) => {
        return {
          ok: true,
          proposal: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  getAsPdf(proposalId) {
    return axios
      .get(`${this.baseUrl}/proposals/${proposalId}/print`, {
        responseType: 'blob',
      })
      .then((response) => {
        return {
          ok: true,
          pdf: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  sendEmail(proposalId, emails, subject, message) {
    const data = {
      proposal: {
        send_to: emails,
        subject: subject,
        message: message,
      },
    };
    return axios
      .put(`${this.baseUrl}/proposals/${proposalId}/email`, data)
      .then((response) => {
        return {
          ok: true,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  withdraw(proposalId) {
    return axios
      .put(`${this.baseUrl}/proposals/${proposalId}/withdraw`)
      .then((response) => {
        return {
          ok: true,
          proposal: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  update(proposalId, values) {
    const apiPayload = {
      proposal: {
        cli_additional_cost: values['additionalCost'],
        cli_additional_cost_desc: values['additionalCostDesc'],
        proposal_quotes_attributes: values['proposal_quotes'],
      },
    };

    return axios
      .put(`${this.baseUrl}/proposals/${proposalId}`, apiPayload)
      .then((response) => {
        return {
          ok: true,
          proposal: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }
}

export const proposalsApi = new ProposalsApi();



// WEBPACK FOOTER //
// ./src/services/api/proposals-api.js